/**
 * Аналитика для саммари на чекауте
 * Все эвенты описаны в документе
 * @see https://docs.google.com/spreadsheets/d/1ZJftJ2drwj6rNFlf2tjmUkHM7QpfX4T6e0kQwTAiMng/edit#gid=0
 */

import { dataLayerPush } from 'src/helpers/gtm';

export const pushTopBarOpened = () => {
  dataLayerPush({ event: 'summary_opened' });
};
